export default {
  menu_user: [
    { id: '7', path: '/external/dashboard', icon: 'th-large', label: 'DASHBOARD', parent: '0' },
    { id: '8', path: '', icon: 'database', label: 'DATABASE', parent: '0' },
    { id: '9', path: '/external/touchpoint', icon: '', label: 'TOUCH POINT', parent: '8' },
    { id: '11', path: '/external/branding', icon: '', label: 'BRANDING', parent: '8' },
    { id: '12', path: '/database/inventory', icon: '', label: 'OOH INVENTORY', parent: '8' },
    { id: '48', path: '/external/community', icon: '', label: 'COMMUNITY', parent: '8' },

    { id: '13', path: '/external/program', icon: 'edit', label: 'PROGRAM', parent: '0' },

    { id: '14', path: '/visualplan', icon: 'laptop', label: 'VISUAL PLAN', parent: '0' },
    { id: '15', path: '', icon: 'bar-chart-o', label: 'REPORT', parent: '0' },
    { id: '16', path: '/external/reportprogram', icon: '', label: 'PROGRAM ', parent: '15' },
    { id: '17', path: '/report/oohvendor', icon: '', label: 'OOH', parent: '15' },
    { id: '206', path: '/report/lamphop', icon: '', label: 'LAMP HOP', parent: '15' },
    { id: '207', path: '/report/dst', icon: '', label: 'DST', parent: '15' },
    { id: '208', path: '/report/community', icon: '', label: 'COMMUNITY', parent: '15' },

    {
      id: '18',
      path: '/external/surveyconsumer',
      icon: 'check-square',
      label: 'SURVEY CONSUMER',
      parent: '0'
    },
    { id: '19', path: '', icon: 'user', label: 'ADMINISTRATION', parent: '0' },
    { id: '20', path: '/masterdata', icon: '', label: 'MASTER DATA', parent: '19' },
    { id: '21', path: '/settings', icon: '', label: 'SETTINGS', parent: '19' },
    { id: '22', path: '/external/dst', icon: '', label: 'DST', parent: '19' },
    { id: '49', path: '/external/admincommunity', icon: '', label: 'COMMUNITY', parent: '19' }
  ],
  menu_vendor: [
    {
      id: '1',
      path: '/vendoraccess/monitoring',
      icon: 'th-large',
      label: 'MONITORING',
      parent: '0'
    },
    { id: '2', path: '/vendoraccess/complaint', icon: 'database', label: 'COMPLAINT', parent: '0' }
  ]
};
